( function () {
	'use strict';

	// USAGE:
	// <visualize id="visualize-container" resource="{ Jaspersoft Reports PATH URL}" params="{ customizations }"></visualize>
	function visualizeDirective ( visualizeService ) {
		function link ( scope, element ) {
			visualizeService.loadReports( scope, element );
		}

		return {
			'link'       : link,
			'restrict'   : 'E',
			'transclude' : true,
			'template'   : '<div ng-transclude></div>',
			'scope'      : {
				'resource' : '=',
				'params'   : '='
			}
		};
	}

	angular
		.module( 'app.components' )
		.directive( 'visualize', visualizeDirective );

	visualizeDirective.$inject = [ 'visualizeService' ];
} )( );
